import { atom } from "recoil";

import { IRydeClientEvents } from "../../models";

export const isSocketEventsConnected = atom({
  key: "isConnected",
  default: false,
});

export const rydeEvents = atom<IRydeClientEvents[]>({
  key: "rydeEvents",
  default: [],
});
